import { ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LangService } from 'src/app/service/lang.service';
import { Subscription } from 'rxjs';
import { MessageService } from 'primeng/api';
import { ToastComponent } from 'src/app/shared/components';
import { NgxUiLoaderService } from 'ngx-ui-loader';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: [MessageService],
  host: {
    '[class.page-ready]': 'pageReady',
  },
})
export class HomeComponent implements OnInit, OnDestroy {
  @ViewChild(ToastComponent) toastComp!: ToastComponent;
  private subscriptions = new Subscription();
  dir = '';
  pageReady = false;
  private pageLoaderActive = false;
  private initialLoadDone = false;

  constructor(
    public route: ActivatedRoute,
    private el: ElementRef,
    public translate: TranslateService,
    public langser: LangService,
    private ngxLoader: NgxUiLoaderService,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.startPageLoader();
    }

    this.subscriptions.add(
      this.langser.getData().subscribe((value) => {
        if (!value) {
          return;
        }
        this.applyLanguage(value, false);
      }),
    );
  }

  ngOnInit(): void {
    const lang = this.langser.getLang() || 'en';
    this.applyLanguage(lang, true);

    this.subscriptions.add(
      this.route.fragment.subscribe((fragment) => {
        if (!fragment || !this.pageReady) {
          return;
        }
        const element = this.el.nativeElement.querySelector(`#${fragment}`);
        element?.scrollIntoView();
      }),
    );
  }

  private applyLanguage(lang: string, isInitialLoad: boolean): void {
    this.dir = lang === 'ar' ? 'rtl' : 'ltr';

    if (isInitialLoad) {
      if (this.translate.currentLang === lang) {
        this.markPageReady();
        return;
      }
      this.subscriptions.add(
        this.translate.use(lang).subscribe({
          next: () => this.markPageReady(),
          error: () => this.markPageReady(),
        }),
      );
      return;
    }

    if (this.translate.currentLang !== lang) {
      this.subscriptions.add(this.translate.use(lang).subscribe());
    }
  }

  private markPageReady(): void {
    if (this.initialLoadDone) {
      return;
    }
    this.initialLoadDone = true;
    requestAnimationFrame(() => {
      this.pageReady = true;
      this.stopPageLoader();
      this.cdr.detectChanges();
    });
  }

  private startPageLoader(): void {
    if (!isPlatformBrowser(this.platformId) || this.pageLoaderActive) {
      return;
    }
    this.ngxLoader.start();
    this.pageLoaderActive = true;
  }

  private stopPageLoader(): void {
    if (!this.pageLoaderActive) {
      return;
    }
    this.ngxLoader.stop();
    this.pageLoaderActive = false;
  }

  ngOnDestroy(): void {
    this.stopPageLoader();
    this.subscriptions.unsubscribe();
  }
}
